/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'GridContainerBlock';
const CLS = 'gridContainerBlock';
const CLS_HIDE = 'd-none';
const CLS_ITEM = 'gridItemBlock';
const MB_IMG_RATIO = 7/6; // mobile image's height ratio

import ImagesLoaded from 'imagesloaded';
import utils from '../utils';
import _ from 'lodash';

export class GridContainerBlock {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$loadMoreBtn = this.$el.find(`.${CLS}-loadMoreBtn`);
		this.$rows = this.$el.find(`.${CLS}-row`);
		this.$item = this.$el.find(`.${CLS}-item`);
		this.$background = this.$el.find(`.${CLS_ITEM}-background`);
		this.$loadMoreWrapper = this.$el.find(`.${CLS}-loadMoreWrapper`);

		this.skipCount = parseInt(this.$el.data('load-skip')) || 0;
		this.totalItem = this.$rows.length;

		this.hideItems();
		this.handleLoadMoreBtn();
		this.onImageLoaded();

		$(window).on('resize', _.debounce(() => {
			this.onImageLoaded();
		}, 300));
	}

	hideItems() {
		if (this.skipCount === 0) {
			this.$loadMoreBtn.addClass(CLS_HIDE);
			this.$loadMoreWrapper.removeClass('py-3');
			this.$el.addClass('show');
			return;
		}

		this.$rows.each((i, item) => {
			let $item = $(item);
			$item.attr('data-index', i);

			// hide items
			if (i + 1 > this.skipCount) {
				$item.addClass(CLS_HIDE);
			}
		});

		// hide load more button
		if (this.totalItem <= this.skipCount) {
			this.$loadMoreBtn.addClass(CLS_HIDE);
			this.$loadMoreWrapper.removeClass('py-3');
		}

		this.$el.addClass('show');
	}

	handleLoadMoreBtn() {
		this.$loadMoreBtn.on('click', () => {
			let visibleItemsCount = this.$el.find(`.${CLS}-row:visible`).length;

			if (visibleItemsCount >= this.totalItem) {
				this.$loadMoreBtn.addClass(CLS_HIDE);
				this.$loadMoreWrapper.removeClass('py-3');
			} else {
				let $showItem = this.$el.find(`.${CLS}-row[data-index="${visibleItemsCount}"]`);
				$showItem.removeClass(CLS_HIDE);

				// hide load more button if last index
				if (visibleItemsCount === this.totalItem - 1) {
					this.$loadMoreBtn.addClass(CLS_HIDE);
					this.$loadMoreWrapper.removeClass('py-3');
				}

				setTimeout(() => {
					$('html, body').animate({
						scrollTop: $showItem.offset().top,
					}, 500);
				}, 250);
			}
		});
	}

	onImageLoaded() {
		if (utils.checkBP('ml')) {
			this.setMobileHieght();
		} else {
			this.setDesktopHeight();
		}
	}

	setDesktopHeight() {
		this.$rows.each((i, row) => {
			let $row = $(row);
			let $background = $row.find(`.${CLS_ITEM}-background`);
			let rowH = 0;
			let opts = {
				background: true,
			};

			new ImagesLoaded($background, opts, (instances) => {
				$.each(instances.images, (i, imgObj) => {
					rowH = imgObj.img.height > rowH ? imgObj.img.height : rowH;
				});

				$row.find(`.${CLS}-item`).css('height', `${rowH}px`);
			});
		});
	}

	setMobileHieght() {
		let w = utils.getWindowWidth();
		let h = w * MB_IMG_RATIO;

		this.$item.css('height', `${h}px`);
	}
}
